module.exports = __webpack_public_path__ + "assets/media/evening.e66e649e.mp3";